import { Component } from 'react'
import { connect } from 'react-redux'
import * as ACT from './actions'
import { Container, Row, Col } from 'reactstrap'
import { Tabs, If } from 'components/ideal-core-ui'
import { DetailsContainer } from './DetailsContainer'
import { Tasks } from 'components/common/Tasks'
import { proposalTasksMapper } from 'utils/serializers'
import { createSelector } from 'reselect'
import { toUsersSelect } from 'components/Users/serializers'
import { ScheduleTaskModal } from 'components/common/modals/ScheduleTaskModal'
import s from './ProposalContainer.scss'
import queryString from 'query-string'
import { makeGetRequest } from 'utils/api'
import update from 'immutability-helper'
import { toDealsByCompany, fromProposals } from './serializers'
import noop from 'lodash/noop'
import { SendForInternalReviewModal } from 'components/common/modals/SendForInternalReviewModal'
import { PageTitle } from 'components/common/PageTitle'
import { withRouter } from 'hocs'
import { ProposalSidebar } from './ProposalSidebar'

const tasksSelector = state => state.tasks
const proposalSelector = state => state.proposal
const proposalTasksSelector = createSelector(
  [tasksSelector, proposalSelector],
  (tasks, proposal) => {
    return proposalTasksMapper(tasks, proposal)
  }
)

const companiesSelector = state => state.deal.dealCompanies
const contactsSelector = createSelector(
  [proposalSelector, companiesSelector],
  (proposal, companies) => {
    return (
      companies.filter(company => company.company.id === proposal.company.id)[0]?.dealContacts || []
    )
  }
)

@withRouter
@connect(({ proposal, users, sidebar }) => {
  const assignees = users.users.length ? users.users : []
  const userList = toUsersSelect(users.users)
  const { tasks, name, deal } = proposal
  return {
    proposal,
    assignees,
    proposalTasks: proposalTasksSelector({ tasks: tasks, proposal: name }),
    users: userList,
    clientContacts: contactsSelector({ proposal, deal }),
    isSidebarOpen: sidebar.proposalSidebar.isOpen
  }
})
class ProposalContainer extends Component {
  state = {
    showScheduleTaskModal: false,
    showSendForInternalReviewModal: false,
    task: null,
    editTasksModal: false,
    companyDeals: null,
    initialFullRender: true,
    dealProposals: []
  }

  componentDidMount() {
    const { id } = this.props.router.params
    this.props.dispatch({
      type: ACT.PROPOSAL_FETCH_REQUESTED,
      payload: {
        id
      }
    })

    this.props.dispatch({ type: ACT.USERS_FETCH_REQUESTED })
    this.props.dispatch({
      type: ACT.PROPOSAL_CONTACTS_HISTOY_FETCH_REQUESTED,
      payload: {
        id
      }
    })
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: ACT.CLEAR_PROPOSAL_FROM_STORE
    })
  }

  componentDidUpdate() {
    const { id } = this.props.proposal.deal
    if (id && this.state.initialFullRender) {
      ;(async () => {
        const url = `/v1/proposals/deal?deal_id=${id}`
        const proposals = await makeGetRequest(url)
        this.setState({
          ...this.state,
          dealProposals: fromProposals(proposals),
          initialFullRender: false
        })
      })()
    }
    if (
      !this.state.companyDeals &&
      this.state.initialFullRender &&
      this.props.proposal.company.id
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(
        {
          ...this.state,
          initialFullRender: false,
          companyDeals: null
        },
        async () => {
          const { id: value, name: label } = this.props.proposal.company
          const url = `/v1/deals/company/${value}/active`
          const deals = await makeGetRequest(url)
          const newState = update(this.state, {
            companyDeals: {
              $set: {
                id: value,
                name: label,
                deals: toDealsByCompany(deals)
              }
            }
          })
          this.setState(newState)
        }
      )
    }
  }

  toggleTasksTab = () => {
    const { id } = this.props.router.params
    const { name } = this.props.proposal
    this.props.dispatch({
      type: ACT.PROPOSAL_TASKS_FETCH_REQUESTED,
      payload: {
        id,
        name
      }
    })
  }

  markTaskAsDone = id => {
    this.props.dispatch({
      type: ACT.PROPOSAL_TASK_MARK_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  markTaskAsNotDone = id => {
    this.props.dispatch({
      type: ACT.PROPOSAL_TASK_MARK_NOT_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  toggleScheduleTaskModal = (params = {}) => {
    this.setState(prevState => ({
      showScheduleTaskModal: !prevState.showScheduleTaskModal,
      editTasksModal: !!params.edit,
      task: params.task || null
    }))
  }

  toggleSendForInternalReviewModal = () => {
    this.setState(prevState => ({
      showSendForInternalReviewModal: !prevState.showSendForInternalReviewModal
    }))
  }

  toggleScheduleTaskModalAndStatusUpdate = (params = {}) => {
    this.setState(
      prevState => ({
        ...prevState,
        defaultSubject: params.defaultSubject,
        onSaveTaskCb: params.onSaveCb
      }),
      () => {
        this.toggleScheduleTaskModal()
      }
    )
  }

  showScheduleTaskModal = (params = {}) => {
    this.setState(
      prevState => ({
        ...prevState,
        defaultSubject: '',
        onSaveTaskCb: noop
      }),
      () => {
        this.toggleScheduleTaskModal(params)
      }
    )
  }

  updateTask = task => {
    this.props.dispatch({
      type: ACT.UPDATE_PROPOSAL_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  deleteTask = task => {
    this.props.dispatch({
      type: ACT.DELETE_PROPOSAL_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  createTask = task => {
    const { id } = this.props.proposal
    this.props.dispatch({
      type: ACT.CREATE_PROPOSAL_TASK_REQUESTED,
      payload: {
        task,
        proposalId: id
      }
    })
  }

  sendForInternalReview = users => {
    const { proposal } = this.props
    this.props.dispatch({
      type: ACT.PROPOSAL_SEND_FOR_REVIEW_REQUESTED,
      payload: {
        proposalId: proposal.id,
        users
      }
    })
    this.toggleSendForInternalReviewModal()
  }

  render() {
    const { proposal, assignees, users, proposalTasks, clientContacts } = this.props
    const { showScheduleTaskModal, editTasksModal, task, showSendForInternalReviewModal } =
      this.state
    const { tab } = queryString.parse(this.props.router.location.search)

    return (
      <section className={s.flexWrapper}>
        <PageTitle detail={proposal?.name} />
        <Container className={s.container}>
          <Row>
            <Col lg={this.props.isSidebarOpen ? '9' : '11'} className={s.main}>
              <Tabs
                withUpdateUrl
                className={s.main}
                activeTabKey={tab || 'details'}
                tabs={[
                  {
                    key: 'details',
                    label: 'Proposal Details',
                    value: (
                      <DetailsContainer
                        proposal={proposal}
                        assignees={assignees}
                        toggleSendForInternalReviewModal={this.toggleSendForInternalReviewModal}
                        toggleScheduleTaskModal={this.toggleScheduleTaskModalAndStatusUpdate}
                        clientContacts={clientContacts}
                      />
                    )
                  },
                  {
                    key: 'tasks',
                    label: 'Tasks',
                    cb: this.toggleTasksTab,
                    value: (
                      <Tasks
                        onMountCallback={this.toggleTasksTab}
                        showScheduleTaskModal={this.showScheduleTaskModal}
                        tasks={proposalTasks}
                        markAsDone={this.markTaskAsDone}
                        markAsNotDone={this.markTaskAsNotDone}
                      />
                    )
                  }
                ]}
              />
            </Col>
            {this.props.isSidebarOpen ? (
              <Col lg="3" className={s.sidebar}>
                <ProposalSidebar
                  proposal={proposal}
                  proposalTasks={proposalTasks}
                  toggleTasksTab={this.toggleTasksTab}
                  showScheduleTaskModal={this.showScheduleTaskModal}
                  markTaskAsDone={this.markTaskAsDone}
                  markTaskAsNotDone={this.markTaskAsNotDone}
                  dealProposals={this.state.dealProposals}
                  companyDeals={this.state.companyDeals}
                />
              </Col>
            ) : (
              <div className={s.sidebarCollapsed}>
                <ProposalSidebar
                  proposal={proposal}
                  proposalTasks={proposalTasks}
                  toggleTasksTab={this.toggleTasksTab}
                  showScheduleTaskModal={this.showScheduleTaskModal}
                  markTaskAsDone={this.markTaskAsDone}
                  markTaskAsNotDone={this.markTaskAsNotDone}
                  dealProposals={this.state.dealProposals}
                  companyDeals={this.state.companyDeals}
                />
              </div>
            )}
          </Row>
        </Container>
        <If condition={showScheduleTaskModal}>
          <ScheduleTaskModal
            showScheduleTaskModal={showScheduleTaskModal}
            toggleScheduleTaskModal={this.toggleScheduleTaskModal}
            createTask={this.createTask}
            updateTask={this.updateTask}
            users={users}
            proposal={proposal}
            edit={editTasksModal}
            selectedTask={task}
            markAsDone={this.markTaskAsDone}
            markAsNotDone={this.markTaskAsNotDone}
            defaultSubject={this.state.defaultSubject}
            onSaveTaskCb={this.state.onSaveTaskCb}
            deleteTask={this.deleteTask}
          />
        </If>
        <SendForInternalReviewModal
          showSendForInternalReviewModal={showSendForInternalReviewModal}
          toggleSendForInternalReviewModal={this.toggleSendForInternalReviewModal}
          sendForInternalReview={this.sendForInternalReview}
        />
      </section>
    )
  }
}

export default ProposalContainer
